/**
 * The one look for a card in Practice - the flashcard, the quiz question, the
 * end-of-run summaries.
 *
 * Practice sits on the same plain paper as every other lesson tab. It used
 * to have a tinted "table" of its own under the cards, which made the tab
 * read as a different screen; the card now carries its own lift - a hairline
 * border (which is what still separates it in dark mode, where a shadow
 * barely shows) and the elevation-2 shadow.
 */
export const PRACTICE_CARD =
  'rounded-2xl border border-border/70 bg-card shadow-elevation-2';
